import { z } from "zod";
import { PACKAGE_STATUSES } from "../types/package.js";

// Validation schemas -- iteration 028 (simplified)

export const createPackageSchema = z.object({
  name: z.string().min(1, "Name is required").max(255),
  description: z.string().max(1000).nullable().optional(),
});

export const updatePackageSchema = z.object({
  name: z.string().min(1, "Name is required").max(255).optional(),
  description: z.string().max(1000).nullable().optional(),
  status: z.enum(PACKAGE_STATUSES, { message: "Invalid package status" }).optional(),
});

export type CreatePackageInput = z.infer<typeof createPackageSchema>;
export type UpdatePackageInput = z.infer<typeof updatePackageSchema>;
